import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ArrowLeft } from "lucide-react";

export const LAST_UPDATED = "15 August 2026";
export const CONTACT_EMAIL = "bhoomiatm@gmail.com";

export const LegalPage = ({ title, subtitle, testid, children }) => (
  <div className="min-h-screen bg-background" data-testid={testid}>
    <header className="sticky top-0 z-30 border-b border-border bg-zinc-950">
      <div className="mx-auto flex max-w-3xl items-center justify-between px-5 py-4 md:px-8">
        <Logo size={26} tone="light" />
        <Link to="/login" data-testid="legal-back-link"
          className="flex items-center gap-1.5 text-xs font-semibold text-zinc-400 transition-colors duration-200 hover:text-white">
          <ArrowLeft size={13} /> Back to sign in
        </Link>
      </div>
    </header>

    <main className="mx-auto max-w-3xl px-5 py-12 md:px-8 md:py-16 rise">
      <p className="label-tiny">Legal</p>
      <h1 className="mt-3 font-display text-3xl md:text-4xl font-bold tracking-tighter">{title}</h1>
      <p className="mt-3 text-sm text-muted-foreground">{subtitle}</p>
      <p className="mt-2 text-xs font-mono text-muted-foreground">Last updated: {LAST_UPDATED}</p>
      <div className="mt-10 space-y-9">{children}</div>

      <div className="mt-16 border-t border-border pt-8 flex flex-wrap items-center justify-between gap-4">
        <p className="text-xs text-muted-foreground">
          Questions? Write to{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-primary hover:underline">{CONTACT_EMAIL}</a>
        </p>
        <div className="flex items-center gap-5 text-xs font-semibold">
          <Link to="/privacy" className="text-primary hover:underline">Privacy Policy</Link>
          <Link to="/terms" className="text-primary hover:underline">Terms of Service</Link>
        </div>
      </div>
    </main>
  </div>
);

export const Section = ({ heading, children }) => (
  <section>
    <h2 className="font-display text-lg md:text-xl font-bold tracking-tight">{heading}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-muted-foreground">{children}</div>
  </section>
);

export const Bullets = ({ items }) => (
  <ul className="list-disc space-y-2 pl-5">
    {items.map((t, i) => <li key={i}>{t}</li>)}
  </ul>
);
